import { render, staticRenderFns } from "./detailCard.vue?vue&type=template&id=1499a118&scoped=true&"
import script from "./detailCard.vue?vue&type=script&lang=js&"
export * from "./detailCard.vue?vue&type=script&lang=js&"
import style0 from "./detailCard.vue?vue&type=style&index=0&id=1499a118&lang=scss&scoped=true&"
import style1 from "./detailCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1499a118",
  null
  
)

export default component.exports